<template>
  <!-- eslint-disable-next-line vue/no-mutating-props -->
  <el-input v-model.trim="formInline[item.key]"
    :placeholder="getValue(item, 'placeholder', placeholder)"
    type="textarea"
    :clearable="getValue(item, 'clearable', false)"
    :disabled="getValue(item, 'disabled', false)"
    :maxlength="getValue(item, 'maxlength', defaultMaxLenght)"
    :show-word-limit="getValue(item, 'showWordLimit', true)"
    :rows="getValue(item, 'rows', 3)"
    >
  </el-input>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
    formInline: {
      type: Object,
      default: () => ({}),
    },
  },
  inject: {
    defaultMaxLenght: 'defaultMaxLenght',
    colon: 'colon',
    customTypeList: 'customTypeList',
    getValue: 'getValue',
    placeholder: 'placeholder',
    selectPlaceholder: 'selectPlaceholder',
    customInputHandle: 'customInputHandle',
    telBlur: 'telBlur',
    numberMax: 'numberMax',
    changeSelect: 'changeSelect',
  },
  data() {
    return {
    }
  },
  watch: {
  },
}
</script>
